module.exports = __webpack_public_path__ + "img/water-droplet-6.7a962f83.png";